<h1 class="bonus-title">{{ "bonus.deposit-offers-title" | translate }}</h1>
<div class="obg-m-bonus-selection-content">
	<button
		mat-flat-button
		[ngClass]="{ 'deposit-button': !(divider$ | async) }"
		class="deposit-without-reward-button"
		color="accent"
		test-id="bonus-selection-make-a-deposit"
		data-test-id="deposit-bonus-deposit-without-bonus-button"
		(click)="itemSelected.emit()"
	>
		{{ "payment.deposit-without-reward.button-title" | translate }}
	</button>
	<div class="bonus-cards">
		<mat-card *ngFor="let item of items; trackBy: itemTrackBy">
			<obg-lazy-image [src]="item.image.url" [alt]="item.image.altText"></obg-lazy-image>
			<mat-card-content>
				<mat-card-title>{{ item.title }}</mat-card-title>
				<div class="bonus-date" *ngIf="item.validUntil || item.claimableUntilDate">
					<span class="ico-tournament-upcoming"></span>
					<div class="bonus-date-details">
						<span class="bonus-date-title">{{ "bonus.expires" | translate }}</span>
						<span class="bonus-date-content">
							{{ (item.validUntil ? item.validUntil : item.claimableUntilDate) | date: "longDate" }}
						</span>
					</div>
				</div>
				<p *ngIf="item.description" [innerHtml]="item.description"></p>
				<button
					mat-flat-button
					color="primary"
					(click)="itemSelected.emit(item)"
					test-id="bonus-selection-claim-a-bonus"
					data-test-id="bonus-selection-claim-a-bonus"
				>
					{{ "bonus.deposit-to-claim" | translate }}
				</button>
				<obg-accordion *ngIf="item.termsAndConditions">
					<obg-accordion-header key="terms">
						<span>{{ "terms-and-conditions.title" | translate }}</span>
						<span class="ico-add-circle"></span>
					</obg-accordion-header>
					<obg-accordion-content key="terms">
						<span [innerHtml]="item.termsAndConditions"></span>
					</obg-accordion-content>
				</obg-accordion>
			</mat-card-content>
		</mat-card>
	</div>
</div>
